
import HereMapsMap from '@/libraries/heremaps/map';
import Geopoint from '@/types/Geopoint';
import { PropType, defineComponent } from 'vue';
import { isNullOrUndefined } from '@/shared/helpers';
import CustomTheme from '@/libraries/heremaps/theme';
import BaseMapPoint from '@/types/BaseMapPoint';
import TruckMapPoint from '@/types/TruckMapPoint';
import NearbyTrailerResult from '@/types/NearbyTrailerResult';

export default defineComponent({
    name: 'EleosMap',
    props: {
        latitude: Number,
        longitude: Number,
        points: Array,
        searchRadius: Number,
        shouldFitMapView: Boolean,
        selectedResult: Object as PropType<NearbyTrailerResult | null>,
    },
    data(): {
        map?: HereMapsMap;
        theme?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
        mapClickEvent: boolean;
    } {
        return {
            map: undefined,
            theme: undefined,
            mapClickEvent: false,
        };
    },
    computed: {
        mapCenter(): Geopoint {
            return new Geopoint(
                this.latitude as number,
                this.longitude as number
            );
        },
    },
    methods: {
        changeView(center: Geopoint, radius?: number): void {
            this.map?.setView(center, radius);
        },
        markerTap(data: any): void {
            // eslint-disable-line @typescript-eslint/no-explicit-any
            if (data instanceof TruckMapPoint) return;
            this.mapClickEvent = true;

            const { lat, lng } = data;
            const center = new Geopoint(lat, lng);

            if (data.type === 'cluster') {
                this.map?.addInfoBubble(
                    center,
                    `
          <div class="tooltip">
            <div>
              <div class="header">This is a customer location</div>
              <div class="footer">It has multiple trailers...</div>
            </div>
          </div>
        `
                );
                return;
            }

            const content = `
        <div class="tooltip">
          <div>
            <div class="header">
              This is a lone trailer
            </div>
            <div>
              It has info
            </div>
            <div class="footer">
              And maybe some less important info
            </div>
          </div>
        </div>
      `;

            this.map?.setInfoBubbleContent(content);

            const mapObject = data.data;
            this.$emit('setSelectedResult', mapObject);
        },
        onMapClick(event: MouseEvent | TouchEvent) {
            this.$emit('onMapClick', event.target as HTMLElement);
        },
        setPoints(points: Array<BaseMapPoint>): void {
            this.map
                ?.clearPoints()
                .addPoint(...points)
                .render();
        },
    },
    watch: {
        mapCenter(val: Geopoint) {
            this.map?.setView(val);
        },
        searchRadius(val: number) {
            this.map?.setView(this.mapCenter, val);
        },
        points(val) {
            this.setPoints(val);
        },
        selectedResult(res) {
            this.map?.fitViewToPoints(!this.mapClickEvent);
            this.map?.highlightSelectedPin(res);

            if (this.mapClickEvent) {
                centerClusterOrTrailer.call(this, res);
                this.mapClickEvent = false;
            }
        },
    },
    mounted() {
        let lat: number, lng: number;
        if (
            isNullOrUndefined(this.latitude) ||
            isNullOrUndefined(this.longitude)
        ) {
            lat = 39.5;
            lng = -98.35;
        } else {
            lat = this.latitude as number;
            lng = this.longitude as number;
        }
        const { VUE_APP_ELEOS_DRIVER_FRONTEND_HERE_MAPS_API_KEY } = process.env;
        this.map = new HereMapsMap(
            VUE_APP_ELEOS_DRIVER_FRONTEND_HERE_MAPS_API_KEY,
            this.$refs.customMapEl as HTMLElement,
            new Geopoint(lat, lng),
            12,
            this.searchRadius,
            this.shouldFitMapView
        );

        this.theme = CustomTheme.create();
        this.map
            .addTheme(this.theme)
            .addClusterTapListener(this.markerTap)
            .render();
    },
    beforeUnmount() {
        this.map?.removeClusterTapListener(this.markerTap).destroy();
    },
});

function centerClusterOrTrailer(this: any, data: any) {
    // eslint-disable-line @typescript-eslint/no-explicit-any
    const cluster = data?.CustomerMapPoint;
    if (cluster) {
        const { location } = data.CustomerMapPoint;
        this.changeView(location);
    } else {
        const { location } = data;
        this.changeView(location);
    }
}
